import { render, staticRenderFns } from "./LearningPackages.vue?vue&type=template&id=d44067ec"
import script from "./LearningPackages.vue?vue&type=script&lang=js"
export * from "./LearningPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports